module.exports = __webpack_public_path__ + "static/img/serum-01-01.3accb1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/serum-01-01.jpg
// module id = 290
// module chunks = 1